// src/js/constants/action-types.js
export const SIDEBAR_ITEM_CLICK = "SIDEBAR_ITEM_CLICK";
export const USER_LOGIN = "USER_LOGIN";
